module.exports = __webpack_public_path__ + "img/rhjx.b8b07026.png";